export default __webpack_public_path__ + "static/media/healthcoach.d7eba0af.svg";